import Component from './SimpleTextKeyValue.component';

export default Component;
